export const CodeDurationEnum = {
  INDEFINITE: {
    value: 0,
    description: 'Indefinite'
  },
  SEVEN_DAYS: {
    value: 7,
    description: '7 days'
  },
  FOURTEEN_DAYS: {
    value: 14,
    description: '14 days'
  },
  TWENTY_EIGHT_DAYS: {
    value: 28,
    description: '28 days'
  },
  THREE_MONTHS: {
    value: 90,
    description: '3 months'
  },
  SIX_MONTHS: {
    value: 180,
    description: '6 months'
  },
  ONE_YEAR: {
    value: 365,
    description: '1 year'
  }
};

// Helper function to get duration description by value
export const getDurationDescription = (value) => {
  const duration = Object.values(CodeDurationEnum).find(d => d.value === value);
  return duration ? duration.description : 'Unknown';
};

// Helper function to get all duration options for dropdowns
export const getDurationOptions = () => {
  return Object.values(CodeDurationEnum).map(duration => ({
    value: duration.value,
    description: duration.description
  }));
};

